"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerType = exports.CustomerTypeLabels = exports.customerTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.customerTypes = [
    'homeowner',
    'contractor',
    'contractorLowVolume',
    'realtor',
    'propertyManager',
    'business',
    'broker',
    'hauler',
    'other',
    'unknown',
];
exports.CustomerTypeLabels = {
    homeowner: 'Homeowner',
    contractor: 'Contractor',
    contractorLowVolume: 'Contractor Low Volume',
    realtor: 'Realtor',
    propertyManager: 'Property Manager',
    business: 'Business',
    broker: 'Broker',
    hauler: 'Another hauler',
    other: 'Other',
    unknown: 'Unknown',
};
exports.CustomerType = typebox_1.Type.Union(exports.customerTypes.map((value) => typebox_1.Type.Literal(value)));
//# sourceMappingURL=customer-type.js.map